import React, { useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

interface LimitedViewWrapperProps extends RouteComponentProps {
    children: React.ReactNode
}

const LimitedViewWrapper: React.FC<LimitedViewWrapperProps> = ({
    location,
    history,
    children
}) => {
    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const isLimitedView = params.get('limitedView')

        if (isLimitedView === 'true') {
            const updateNavigation = (e: MouseEvent) => {
                const target = e.target as HTMLAnchorElement

                if (
                    target.tagName === 'A' ||
                    target.tagName === 'SPAN' ||
                    target.tagName === 'BUTTON'
                ) {
                    const newUrl = new URL(window.location.href)

                    if (!newUrl.searchParams.get('limitedView')) {
                        newUrl.searchParams.set('limitedView', 'true')
                        e.preventDefault()
                        history.push(newUrl.pathname + newUrl.search)
                    }
                }
            }

            document.addEventListener('click', updateNavigation)

            return () => {
                document.removeEventListener('click', updateNavigation)
            }
        }
    }, [location.search, history])

    return <>{children}</>
}

export default withRouter(LimitedViewWrapper)
